module.exports = __webpack_public_path__ + "assets/devices/RP-600-PG2-white-ccd2501d9df8903a5d7a2de7e3d4fd5e.svg";